import { claw, dragon } from '../beasts';
import { hangingCharm } from '../motifs';
import { INK, M } from '../palette';
import { registerPlate } from '../registry';

/** 11 มังกรฟ้า: the sky dragon's plate, a gold dragon coiling up the left end of black lacquer. */
registerPlate({
  id: 'sky-dragon',
  name: 'มังกรฟ้า',
  ground: INK,
  trim: M.goldLo,
  text: { fill: [M.goldHi, M.gold], line: '#0c0808' },
  inset: [17, 11],
  tassels: [{ x: -3, charm: 'coin', len: 7, cord: 3 }],
  front(p, f) {
    dragon(
      p,
      [
        [f.x + 10, f.b + 9],
        [f.x - 3, f.b + 2],
        [f.x - 2, f.cy],
        [f.x + 9, f.cy - 2],
        [f.x + 8, f.y - 4],
        [f.x + 3, f.y - 7],
        [f.x + 7, f.y - 10],
      ],
      5,
    );
    claw(p, f.x + 10, f.cy + 1);
    claw(p, f.x - 4, f.b - 2, true);
    hangingCharm(p, f.r - 8, f.b, 4);
  },
  motion: {
    sprites: {
      glint: {
        w: 5,
        h: 5,
        draw: (p) => p.rect(2, 0, 1, 5, M.whiteHi).rect(0, 2, 5, 1, M.whiteHi).px(2, 2, '#ffffff'),
      },
      pearl: { w: 3, h: 3, draw: (p) => p.disc(1.5, 1.5, 1.5, '#fff4d0').px(2, 0.5, '#ffffff') },
    },
    play(a, t, f) {
      // The dragon's pearl bobbing before its jaws, and a glint running down its coils.
      a.spr('pearl', f.x + 21, f.y - 10 + Math.round(Math.sin(t * 2) * 1.5));
      const ph = (t * 0.5) % 2;
      if (ph < 1) a.spr('glint', f.x + 4 - Math.sin(ph * 6) * 4, f.y - 8 + ph * 26, Math.sin(ph * Math.PI));
    },
  },
});
